import { CalendarManager, Retail } from '@benzinga/calendar-manager';
import { Session } from '@benzinga/session';
import { injectLogos } from '../lib/utils';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

const fetchRetail = (session: Session, params = {}, injectTickersLogos = true, pageSize = 100): Promise<Retail[]> => {
  return session
    .getManager(CalendarManager)
    .getCalendarData('retail', { ...params, pageSize })
    .then(res => {
      if (res.ok && res.ok.length) {
        return injectTickersLogos ? injectLogos(res.ok, session) : res.ok;
      }
      return [];
    })
    .catch(error => {
      logCalendarFetchFailure('retail-sales', error);
      return [];
    });
};

export { fetchRetail };
